import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-driver-ledger-delete-confirm',
	standalone: true,
	imports: [MatButtonModule, MatDialogModule],
	template: `
		<h2 mat-dialog-title>Usuwanie wpisu</h2>
		<mat-dialog-content>Czy na pewno chcesz usunąć ten wpis?</mat-dialog-content>
		<mat-dialog-actions align="end">
			<button mat-stroked-button (click)="dialogRef.close(false)">Anuluj</button>
			<button mat-raised-button color="warn" (click)="dialogRef.close(true)">Usuń</button>
		</mat-dialog-actions>
	`,
})
export class DriverLedgerDeleteConfirmComponent {
	readonly dialogRef = inject(MatDialogRef<DriverLedgerDeleteConfirmComponent>);
}
